const helpConfig = [
        {path: '/help/support-ticket', menuText: 'SUPPORT'},
        {link: 'https://docs.actzero.ai/', menuText: 'DOCUMENTATION'},
        {link: 'https://docs.actzero.ai/release-notes/', menuText: 'RELEASE NOTES'},
        {link: 'https://docs.actzero.ai/endpoints/crowdstrike/install-agent/', menuText: 'AGENT INSTALLER'},
        {link: 'https://forms.gle/mzWPHoAZYCKE2iyXA', menuText: 'SEND FEEDBACK'}
]
  
export default helpConfig;
  